//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'Sales',
  data() {
    return {
      imgUrlLight: 'https://static.moele.me/img/signup/contributors/contributors-sales-dashboard-preview-light.221109.png',
      imgUrlDark: 'https://static.moele.me/img/signup/contributors/contributors-sales-dashboard-preview-dark.221109.png',
    };
  },
  computed: {
    ...mapState({
      uiMode: state => state.user.preferences.ui.mode,
    }),
  },
};
